import React, { useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import TryFourteenDays from "../TryFourteenDays";
import { useNavigate } from "react-router-dom";

function UnlimitedUsers() {
  const navigate = useNavigate();
  const applyAnimation = () => {
    const sections = document.querySelectorAll('[class^="section-"]');

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const position = section.getBoundingClientRect();

      // If the top of the section is in the viewport
      if (position.top < window.innerHeight && position.bottom > 0) {
        const leftDiv = section.querySelector(".left-div");
        if (leftDiv) {
          leftDiv.style.animation = "slideInLeft 1s ease forwards";
        }

        const rightDiv = section.querySelector(".right-div");
        if (rightDiv) {
          rightDiv.style.animation = "slideInRight 1s ease forwards";
        }

        const upDiv = section.querySelector(".up-div");
        if (upDiv) {
          upDiv.style.animation = "slideInUp 1s ease forwards";
        }

        const downDiv = section.querySelector(".down-div");
        if (downDiv) {
          downDiv.style.animation = "slideInDown 1s ease forwards";
        }
      } else {
        // If the section is out of view, revert the animation
        const leftDiv = section.querySelector(".left-div");
        if (leftDiv) {
          leftDiv.style.animation = "none";
        }

        const rightDiv = section.querySelector(".right-div");
        if (rightDiv) {
          rightDiv.style.animation = "none";
        }

        const upDiv = section.querySelector(".up-div");
        if (upDiv) {
          upDiv.style.animation = "none";
        }

        const downDiv = section.querySelector(".down-div");
        if (downDiv) {
          downDiv.style.animation = "none";
        }
      }
    }
  };
  const scrollToTarget = (id) => {
    const targetElement = document.getElementsByClassName(`section-${id}`)[0];
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    // Check position on scroll
    window.addEventListener("scroll", applyAnimation);

    // Cleanup event listener
    return () => {
      window.removeEventListener("scroll", applyAnimation);
    };
  }, []);
  return (
    <div className="pageStructure">
      <div className="prizeBanner">
        <Typography
          variant="h2"
          sx={{ textAlign: "center", color: "white" }}
          gutterBottom
        >
          Inrichting
        </Typography>
        <Typography variant="h5" sx={{ textAlign: "center" }} gutterBottom>
          Onbeperkt gebruikers (medewerkers) aanmaken in boekhoudsoftware
        </Typography>
        <Typography variant="h5" sx={{ textAlign: "center" }} gutterBottom>
          " De boekhoudsoftware biedt de mogelijkheid om onbeperkt gebruikers
          aan te maken. Dit is handig voor bedrijven met meerdere medewerkers.
          Deze gebruikers kunnen allemaal tegelijk inloggen."
        </Typography>

        <div style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            sx={{ color: "white" }}
            onClick={() => navigate("/dashboard")}
          >
            Nu Gratis Proberen! 00,0 / 14 dagen
          </Button>
        </div>
      </div>
      <div style={{ padding: "2rem", paddingBottom: "0px" }}>
        <Typography variant="h4" className="titleUponDivider" gutterBottom>
          De mogelijkheden voor onbeperkt gebruikers aanmaken met Dashbook
        </Typography>
      </div>

      <div
        className="buttonBox"
        style={{
          padding: "1rem 3rem",
          paddingTop: "0rem !important",
          overflowX: "scroll",
        }}
      >
        <Button
          variant="contained"
          className={`buttonDesign`}
          onClick={() => scrollToTarget(1)}
        >
          Onbeperkt gebruikers
        </Button>
      </div>
      <div
        style={{ textAlign: "center", marginBottom: "3rem" }}
        className="section-1"
      >
        <Divider textAlign="left" className="divider">
          {"Onbeperkt gebruikers".toUpperCase()}
        </Divider>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} md={6} lg={6} sm={12} sx={{ alignSelf: "center" }}>
            <div className="left-div card">
              <Typography variant="h5" gutterBottom>
                Onbeperkt gebruikers
              </Typography>

              <Typography variant="subtitle1" gutterBottom>
                <strong>Voordelen: </strong>Onbeperkte gebruikersmogelijkheden
                betekenen dat alle medewerkers gelijktijdig kunnen inloggen en
                aan de boekhouding kunnen werken, wat zorgt voor tijdsbesparing
                en efficiëntie.
              </Typography>

              <Typography variant="subtitle1" gutterBottom>
                <strong>Beveiliging: </strong>Door het instellen van rechten en
                rollen voor elke gebruiker, zorg je ervoor dat alleen
                geautoriseerde personen toegang hebben tot specifieke gegevens.
                Dit waarborgt de beveiliging van je boekhouding.
              </Typography>

              <Typography variant="subtitle1" gutterBottom>
                <strong>Transparantie: </strong>Altijd inzicht hebben in wie
                welke gegevens heeft bekeken of gewijzigd, draagt bij aan een
                gecontroleerde boekhouding en versterkt de transparantie binnen
                het systeem.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6} sm={12} sx={{ alignSelf: "center" }}>
            <div className="right-div imageCard">
              <img
                src={"./Professional/UnlimitedUsersIcon.png"}
                alt="Logo"
                height={"350px"}
                style={{
                  margin: "auto 0px",
                  display: "inline-block",
                }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      <TryFourteenDays />
    </div>
  );
}

export default UnlimitedUsers;
